module.exports = __webpack_public_path__ + "img/ar.0c6d2fa1.svg";